// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Exit: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<polygon points="1.89,1.45 14.69,1.45 14.69,0.05 0.49,0.05 0.49,23.95 14.69,23.95 14.69,22.55 1.89,22.55 "/>
<polygon points="19.88,8.22 18.89,9.21 20.83,11.14 10.17,11.14 10.17,12.54 20.83,12.54 18.89,14.48 19.88,15.47 23.51,11.84 "/>
</svg>;
};

export default React.memo(Exit);
